import { SYMPTOMS } from '../config/constants'
import { useEstimate } from '../context/EstimateContext'
import { ChevronRight } from '../components/icons'

export default function SymptomStep() {
  const { setSymptom } = useEstimate()

  return (
    <div className="animate-fade-in">
      <h1 className="text-[26px] font-bold leading-[1.15] text-ink">
        What&apos;s going on with your water heater?
      </h1>
      <p className="mt-2.5 text-sm leading-relaxed text-muted">
        Pick the closest match. You&apos;ll get an honest, no-pressure estimate in about a minute — no
        phone call, no waiting for a callback.
      </p>

      <div className="mt-6 space-y-3">
        {SYMPTOMS.map((s) => (
          <button
            key={s.key}
            onClick={() => setSymptom(s.key)}
            className="group flex w-full items-center gap-4 rounded-3xl border border-white/70 bg-white/80 p-4 text-left shadow-glass backdrop-blur-xl transition duration-200 hover:-translate-y-0.5 hover:border-brand-200 hover:shadow-glass-lg active:translate-y-0"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-soft text-2xl leading-none">
              <span aria-hidden="true">{s.emoji}</span>
            </span>
            <span className="min-w-0 flex-1">
              <span className="block font-display text-[15px] font-semibold text-ink">{s.label}</span>
              <span className="mt-0.5 block text-xs leading-snug text-muted">{s.blurb}</span>
            </span>
            <ChevronRight className="h-5 w-5 shrink-0 text-slate-300 transition-colors group-hover:text-brand-500" />
          </button>
        ))}
      </div>
    </div>
  )
}
